__turbopack_context__.v({
  "forgotPasswordContainer": "page-module__rur6OG__forgotPasswordContainer",
  "form": "page-module__rur6OG__form",
  "loadingContainer": "page-module__rur6OG__loadingContainer",
  "loadingText": "page-module__rur6OG__loadingText",
  "loadingTitle": "page-module__rur6OG__loadingTitle",
  "magicLinkButton": "page-module__rur6OG__magicLinkButton",
  "orDivider": "page-module__rur6OG__orDivider",
  "orLabel": "page-module__rur6OG__orLabel",
  "spin": "page-module__rur6OG__spin",
  "spinner": "page-module__rur6OG__spinner",
  "title": "page-module__rur6OG__title",
});
